import { timeago } from '@/utils/date-util'

/**
 * How long ago the date was, as "5 minutes ago".
 *
 * @param date
 * @param now
 */
export function formatRelativeTime(date: Date, now?: Date) {
  const ago = timeago(date, 'long', now)
  return ago === 'now' ? 'just now' : `${ago} ago`
}
